var _circle, _g, _circle2, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUploadAwaiting = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 23,
    r: 19,
    fill: "#FFC633"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_48_5693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1747 19.328L21.1497 15.464C20.8413 15.168 20.4163 15 19.9747 15H13.9997C13.083 15 12.3413 15.72 12.3413 16.6L12.333 29.4C12.333 30.28 13.0747 31 13.9913 31H23.9997C24.9163 31 25.6663 30.28 25.6663 29.4V20.464C25.6663 20.04 25.4913 19.632 25.1747 19.328ZM21.333 25.4H19.833V27.8C19.833 28.24 19.458 28.6 18.9997 28.6C18.5413 28.6 18.1663 28.24 18.1663 27.8V25.4H16.6747C16.2997 25.4 16.1163 24.968 16.383 24.72L18.7163 22.488C18.883 22.336 19.1413 22.336 19.308 22.488L21.633 24.72C21.883 24.968 21.6997 25.4 21.333 25.4ZM20.6663 20.6C20.208 20.6 19.833 20.24 19.833 19.8V16.2L24.4163 20.6H20.6663Z",
    fill: "white"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 9,
    r: 8,
    fill: "#FFC633",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 11V13H34V11H32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 5V10H34V5H32Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_48_5693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(11 15)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUploadAwaiting);
export default ForwardRef;